/**
 * Remember where a signed-out user was headed (e.g. a shared-chat link) so
 * sign-in returns them there instead of always landing on /my-agents.
 *
 * sessionStorage, not router state, because the Google sign-in leaves the
 * app for the identity provider and comes back through /auth/callback.
 */
const KEY = 'postLoginRedirect';

/** Only same-app paths — never "//evil.com" or an absolute URL. */
const isSafePath = (p: string) => p.startsWith('/') && !p.startsWith('//') && !p.startsWith('/login') && !p.startsWith('/auth');

export function rememberPostLoginRedirect(path: string) {
  try {
    if (isSafePath(path)) sessionStorage.setItem(KEY, path);
  } catch {
    /* storage blocked: fall back to the default landing page */
  }
}

export function consumePostLoginRedirect(fallback = '/my-agents'): string {
  try {
    const p = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return p && isSafePath(p) ? p : fallback;
  } catch {
    return fallback;
  }
}
